import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardList, Activity, Dumbbell, ShieldAlert, Users, HeartPulse, Check } from 'lucide-react';
const tomos = [{
  id: 'T1',
  title: 'Evaluación y Valoración',
  subtitle: '8+ recursos listos',
  icon: ClipboardList
}, {
  id: 'T2',
  title: 'Movilidad y Flexibilidad',
  subtitle: '10 clases',
  icon: Activity
}, {
  id: 'T3',
  title: 'Fuerza y Resistencia Adaptada',
  subtitle: '10 clases',
  icon: Dumbbell
}, {
  id: 'T4',
  title: 'Equilibrio y Prevención de Caídas',
  subtitle: '10 clases',
  icon: ShieldAlert
}, {
  id: 'T5',
  title: 'Clases Grupales Listas para Dar',
  subtitle: '15 clases',
  icon: Users
}, {
  id: 'T6',
  title: 'Patologías Frecuentes y Adaptaciones',
  subtitle: '10 protocolos',
  icon: HeartPulse,
  highlight: true
}];
const checklist = ['Planificación lista para usar desde el primer día', 'Clases con objetivo, desarrollo y cierre', 'Indicaciones listas para dar palabra por palabra', 'Variaciones Nivel 1, Nivel 2 y Nivel 3 por ejercicio', 'Checklist pre y durante la clase', 'Planillas de seguimiento de alumnos', 'Adaptaciones para grupos heterogéneos', '100% adaptado al contexto formativo argentino'];
export function TomosGrid() {
  return <section className="py-10 md:py-20 px-4 bg-navy-50" data-id="element-285">
      <div className="max-w-6xl mx-auto" data-id="element-286">
        <div className="text-center mb-8 md:mb-16" data-id="element-287">
          <h2 className="font-display text-4xl md:text-5xl text-navy-900 mb-4 tracking-wide uppercase" data-id="element-288">
            LOS 6 TOMOS
          </h2>
          <p className="text-xl text-navy-600 font-medium" data-id="element-289">
            Para profes y kinesiólogos de todos los niveles y enfoques
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-8 md:mb-16" data-id="element-290">
          {tomos.map((tomo, idx) => {
          const Icon = tomo.icon;
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className={`relative bg-white p-8 rounded-2xl shadow-sm border-2 ${tomo.highlight ? 'border-gold shadow-gold/20 shadow-lg' : 'border-navy-100'} flex flex-col items-center text-center`} data-id="element-291">
                {tomo.highlight && <div className="absolute -top-4 bg-gold text-navy-900 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider flex items-center gap-1" data-id="element-292">
                    <span data-id="element-293">⭐</span> Incluido en Pack Completo
                  </div>}
                <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-6 ${tomo.highlight ? 'bg-gold/20 text-gold' : 'bg-navy-100 text-navy-600'}`} data-id="element-294">
                  <Icon size={32} data-id="element-295" />
                </div>
                <div className="text-gold font-display text-3xl mb-2" data-id="element-296">
                  {tomo.id}
                </div>
                <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-297">
                  {tomo.title}
                </h3>
                <p className="text-navy-500 font-medium" data-id="element-298">{tomo.subtitle}</p>
              </motion.div>;
        })}
        </div>

        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-navy-100 max-w-4xl mx-auto" data-id="element-299">
          <h3 className="text-2xl font-bold text-navy-900 mb-8 text-center" data-id="element-300">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8" data-id="element-301">
            {checklist.map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-302">
                <div className="mt-1 bg-green-100 p-1 rounded-full text-green-600 shrink-0" data-id="element-303">
                  <Check size={16} strokeWidth={3} data-id="element-304" />
                </div>
                <p className="text-navy-700 font-medium" data-id="element-305">{item}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}